



export const WHATSAPP_SERVICE_CONFIG = {
    CURRENT_WHATSAPP_PLATFORMS : "CURRENT_WHATSAPP_PLATFORMS",
    CURRENT_SELECTED_WHATSAPP_PLATFORM: "CURRENT_SELECTED_WHATSAPP_PLATFORM",
    BAILEY_WHATSAPP_NUMBER: "BAILEY_WHATSAPP_NUMBER"
}


